// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1TBy9","notes":"Notes_notes__1CJtS"};